import { Icon } from '@virtidev/toolbox';
import styled, { css } from 'styled-components';

export const ObjectiveWrapper = styled.div`
  margin-left: 24px;
  margin-right: 48px;
`;
export const Objective = styled.button`
  ${({
    theme,
    clickableToShowHint,
    wasHit,
    hasShownHint,
    easyMode,
    hintActive,
  }) => css`
    padding: 0.5rem 1rem;
    height: 48px;
    border: none;
    text-align: left;
    border-radius: 12px;
    color: #fff;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
    background: #fff;
    opacity: 0.9;
    color: var(--pd-dark-text-color);

    ${clickableToShowHint &&
    css`
      cursor: pointer;
    `}

    ${wasHit &&
    css`
      cursor: default;
    `}

    ${!wasHit &&
    !hasShownHint &&
    !easyMode &&
    css`
      justify-content: center;
    `}

    ${hintActive &&
    css`
      background-color: ${theme.color.primary};
      color: ${theme.color.contrast.primary};
    `}
  `}
`;
export const ObjectiveContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
`;
export const ObjectiveName = styled.div`
  ${({ wasHit }) => css`
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    ${wasHit &&
    css`
      text-decoration: line-through;
    `}
  `}
`;
export const ObjectiveIcon = styled.div``;
export const ObjectiveHintedIconWrapper = styled.div`
  font-size: 1.2rem;
  color: var(--negative-color);
`;
export const ObjectiveUnknownIcon = styled(Icon)`
  color: var(--primary-color);
  font-size: 1.4rem;
`;
